/**
 * AURALA: SECTION PRODUCT SKU BLOCK
 * Mobile/Tablet image click-to-swap functionality
 * Desktop hover is handled by CSS only
 */

(function() {
  'use strict';

  /* -------------------------------
     Variant button selection (SKU block + PDP using SKU block)
     - No change to Shopify logic
     - Just wires button clicks to existing hidden input + price DOM
  -------------------------------- */

  function formatMoney(cents) {
    try {
      if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
        const fmt = window.Shopify.money_format || window.Shopify.money_with_currency_format;
        return window.Shopify.formatMoney(cents, fmt);
      }
    } catch (e) {}
    return '$' + (cents / 100).toFixed(2);
  }

  function parseProductJson(root) {
    const script = root.querySelector('script[type="application/json"]');
    if (!script) return null;
    try {
      return JSON.parse(script.textContent);
    } catch (e) {
      return null;
    }
  }

  function getAfterpayPriceMap(section) {
    if (!section) return null;
    if (section.__afterpayPriceMap) return section.__afterpayPriceMap;
    const sectionId = section.dataset.sectionId;
    if (!sectionId) return null;
    const script = document.getElementById(`AfterpayVariants-${sectionId}`);
    if (!script) return null;
    try {
      const variants = JSON.parse(script.textContent || '[]');
      const map = {};
      variants.forEach((variant) => {
        if (variant && variant.id) map[variant.id] = variant.price;
      });
      section.__afterpayPriceMap = map;
      return map;
    } catch (e) {
      return null;
    }
  }

  function updateAfterpayAmountInSection(section, priceCents) {
    if (!section) return;
    const afterpay = section.querySelector('[data-afterpay]');
    if (!afterpay) return;
    const amountEl = afterpay.querySelector('.sku-afterpay__amount');
    if (!amountEl) return;
    if (typeof priceCents !== 'number' || Number.isNaN(priceCents)) {
      afterpay.hidden = true;
      return;
    }
    const installment = Math.ceil(priceCents / 4);
    amountEl.textContent = formatMoney(installment);
    afterpay.hidden = false;
  }

  function updateAfterpayFromVariantId(section, variantId) {
    const map = getAfterpayPriceMap(section);
    if (!map) return;
    updateAfterpayAmountInSection(section, map[Number(variantId)]);
  }

  function initVariantButtons(scope) {
    const roots = (scope || document).querySelectorAll('.section-product-sku-block variant-selects');
    roots.forEach((vs) => {
      if (vs.dataset.auralaVariantButtonsInit === 'true') return;
      vs.dataset.auralaVariantButtonsInit = 'true';

      const sectionId = vs.dataset.section;
      const form = vs.closest('form');
      const variantInput = form ? form.querySelector('input[name="id"]') : null;
      const submitButton = form ? form.querySelector('[type="submit"]') : null;
      const priceContainer = sectionId ? document.getElementById(`price-${sectionId}`) : null;
      const priceEl = priceContainer ? priceContainer.querySelector('.price') : null;
      let compareEl = priceContainer ? priceContainer.querySelector('.compare-price') : null;

      const productData = parseProductJson(vs);
      const skuBlock = vs.closest('.section-product-sku-block');

      const buttons = Array.from(vs.querySelectorAll('.variant-button'));
      if (buttons.length === 0 || !variantInput) return;

      const initialSelected = buttons.find((b) => b.classList.contains('variant-button--selected')) || buttons[0];
      if (initialSelected) {
        const initialCents = parseInt(initialSelected.dataset.variantPrice || '0', 10);
        updateAfterpayAmountInSection(skuBlock, initialCents);
      } else {
        updateAfterpayFromVariantId(skuBlock, variantInput.value);
      }

      variantInput.addEventListener('change', () => {
        updateAfterpayFromVariantId(skuBlock, variantInput.value);
      });

      function setSelected(nextId) {
        buttons.forEach((b) => {
          const id = parseInt(b.dataset.variantId, 10);
          const isSelected = id === nextId;
          b.classList.toggle('variant-button--selected', isSelected);
          b.setAttribute('aria-pressed', isSelected ? 'true' : 'false');

          // Toggle savings badge highlight (grey -> green) when present
          const badge = b.querySelector('.variant-savings-badge');
          if (badge) badge.classList.toggle('variant-savings-badge--selected', isSelected);
        });
      }

      function updatePrice(nextId, btn) {
        if (!priceContainer || !priceEl) return;
        const cents = parseInt(btn.dataset.variantPrice || '0', 10);
        const compareCents = parseInt(btn.dataset.variantComparePrice || '0', 10);

        priceEl.textContent = formatMoney(cents);

        if (compareCents && compareCents > cents) {
          if (!compareEl) {
            compareEl = document.createElement('span');
            compareEl.className = 'compare-price text-base text-muted-foreground line-through';
            priceContainer.insertBefore(compareEl, priceEl);
          }
          compareEl.textContent = formatMoney(compareCents);
          compareEl.style.display = '';
        } else if (compareEl) {
          compareEl.style.display = 'none';
        }
      }

      function updateTitle(nextId, btn) {
        const root = btn?.closest('variant-selects') || vs;
        const container = root || skuBlock || document;
        const titleEls = container.querySelectorAll('.sku-selected-variant-title');
        const separatorEls = container.querySelectorAll('.sku-variant-separator');
        if (titleEls.length === 0) return;
        let title = btn?.dataset?.variantTitle || '';
        if (!title && productData && Array.isArray(productData.variants)) {
          const v = productData.variants.find((x) => x && x.id === nextId);
          title = v ? v.title : '';
        }
        if (title && title !== 'Default Title') {
          titleEls.forEach((el) => {
            el.textContent = title;
            el.classList.remove('hidden');
          });
          separatorEls.forEach((el) => el.classList.remove('hidden'));
        } else {
          titleEls.forEach((el) => {
            el.textContent = '';
            el.classList.add('hidden');
          });
          separatorEls.forEach((el) => el.classList.add('hidden'));
        }
      }

      function updateAvailability(nextId) {
        if (!submitButton || !productData || !Array.isArray(productData.variants)) return;
        const v = productData.variants.find((x) => x && x.id === nextId);
        if (!v) return;
        submitButton.disabled = !v.available;
      }

      buttons.forEach((btn) => {
        btn.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();

        const nextId = parseInt(btn.dataset.variantId, 10);
        if (!nextId || Number.isNaN(nextId)) return;

        variantInput.value = String(nextId);
        variantInput.dispatchEvent(new Event('change', { bubbles: true }));
        setSelected(nextId);
        updatePrice(nextId, btn);
        updateTitle(nextId, btn);
        updateAvailability(nextId);
        const cents = parseInt(btn.dataset.variantPrice || '0', 10);
        updateAfterpayAmountInSection(skuBlock, cents);
        });
      });
    });
  }

  /* Delegated click handler (capture) to ensure variant buttons always work on PDP */
  function initVariantButtonsDelegated() {
    if (document.documentElement.dataset.auralaSkuVariantDelegation === 'true') return;
    document.documentElement.dataset.auralaSkuVariantDelegation = 'true';

    document.addEventListener(
      'click',
      (e) => {
        const btn = e.target.closest('.section-product-sku-block .variant-button');
        if (!btn) return;

        const vs = btn.closest('variant-selects');
        if (!vs) return;

        const form = vs.closest('form');
        const variantInput = form ? form.querySelector('input[name="id"]') : null;
        if (!variantInput) return;

        const sectionId = vs.dataset.section;
        const priceContainer = sectionId ? document.getElementById(`price-${sectionId}`) : null;
        const priceEl = priceContainer ? priceContainer.querySelector('.price') : null;
        let compareEl = priceContainer ? priceContainer.querySelector('.compare-price') : null;

        const productData = parseProductJson(vs);
        const skuBlock = vs.closest('.section-product-sku-block');
        const submitButton = form ? form.querySelector('[type="submit"]') : null;

        const nextId = parseInt(btn.dataset.variantId, 10);
        if (!nextId || Number.isNaN(nextId)) return;

        e.preventDefault();
        e.stopPropagation();

        variantInput.value = String(nextId);
        variantInput.dispatchEvent(new Event('change', { bubbles: true }));

        // Update selected styles
        vs.querySelectorAll('.variant-button').forEach((b) => {
          const id = parseInt(b.dataset.variantId, 10);
          const isSelected = id === nextId;
          b.classList.toggle('variant-button--selected', isSelected);
          b.setAttribute('aria-pressed', isSelected ? 'true' : 'false');

          const badge = b.querySelector('.variant-savings-badge');
          if (badge) badge.classList.toggle('variant-savings-badge--selected', isSelected);
        });

        const cents = parseInt(btn.dataset.variantPrice || '0', 10);
        const compareCents = parseInt(btn.dataset.variantComparePrice || '0', 10);

        // Update price (from button data)
        if (priceContainer && priceEl) {
          priceEl.textContent = formatMoney(cents);

          if (compareCents && compareCents > cents) {
            if (!compareEl) {
              compareEl = document.createElement('span');
              compareEl.className = 'compare-price text-base text-muted-foreground line-through';
              priceContainer.insertBefore(compareEl, priceEl);
            }
            compareEl.textContent = formatMoney(compareCents);
            compareEl.style.display = '';
          } else if (compareEl) {
            compareEl.style.display = 'none';
          }
        }

        updateAfterpayAmountInSection(skuBlock, cents);

        // Update displayed variant title + availability (from data attrs or product JSON)
        // Update title within the closest SKU block to this button.
        const titleRoot = skuBlock || vs;
        const titleEls = titleRoot.querySelectorAll('.sku-selected-variant-title');
        const separatorEls = titleRoot.querySelectorAll('.sku-variant-separator');
        if (titleEls.length > 0) {
          const title = btn?.dataset?.variantTitle || '';
          if (title && title !== 'Default Title') {
            titleEls.forEach((el) => {
              el.textContent = title;
              el.classList.remove('hidden');
            });
            separatorEls.forEach((el) => el.classList.remove('hidden'));
          } else {
            titleEls.forEach((el) => {
              el.textContent = '';
              el.classList.add('hidden');
            });
            separatorEls.forEach((el) => el.classList.add('hidden'));
          }
        }
        if (productData && Array.isArray(productData.variants)) {
          const v = productData.variants.find((x) => x && x.id === nextId);
          if (v && submitButton) submitButton.disabled = !v.available;
        }
      },
      true
    );
  }

  // Detect if device is touch-only (mobile/tablet)
  // Returns true if device does NOT support hover (i.e., is touch device)
  function isTouchDevice() {
    // Check if device does NOT have hover capability
    const hasHover = window.matchMedia('(hover: hover)').matches;
    const hasFinePointer = window.matchMedia('(pointer: fine)').matches;
    
    // Touch device = no hover OR no fine pointer
    return !hasHover || !hasFinePointer;
  }

  // Initialize image swap on click for mobile/tablet ONLY
  function initMobileImageSwap() {
    // Step 1: Check if this is a touch device
    const isTouch = isTouchDevice();
    
    // Step 2: Exit early on desktop - let CSS handle hover
    if (!isTouch) {
      console.log('[SKU Image Swap] Desktop detected - skipping click handlers');
      return;
    }

    console.log('[SKU Image Swap] Touch device detected - initializing click handlers');

    // Step 3: Find all image containers
    const containers = document.querySelectorAll('.section-product-sku-block .product-image-container');
    console.log('[SKU Image Swap] Found containers:', containers.length);
    
    if (containers.length === 0) {
      console.log('[SKU Image Swap] No containers found');
      return;
    }
    
    // Step 4: Attach handlers to each container
    containers.forEach((container, index) => {
      const primary = container.querySelector('.product-image-primary');
      const secondary = container.querySelector('.product-image-secondary');
      const imageFirst = container.dataset.imageFirst || 'primary';
      const firstImage = imageFirst === 'secondary' ? secondary : primary;
      const altImage = imageFirst === 'secondary' ? primary : secondary;
      
      console.log(`[SKU Image Swap] Container ${index}:`, {
        primary: !!primary,
        secondary: !!secondary
      });
      
      // Skip if no secondary image
      if (!firstImage || !altImage) {
        console.log(`[SKU Image Swap] Container ${index}: Skipping - missing images`);
        return;
      }

      let timeoutId = null;
      const SWAP_DURATION = 3000; // 3 seconds
      let isCurrentlySwapped = false;

      function swapToSecondary() {
        console.log('[SKU Image Swap] swapToSecondary called, isCurrentlySwapped:', isCurrentlySwapped);
        
        // If already swapped, just restart the timer
        if (isCurrentlySwapped) {
          console.log('[SKU Image Swap] Already swapped - restarting timer');
          // Clear existing timeout
          if (timeoutId) {
            clearTimeout(timeoutId);
          }
          // Restart timer
          timeoutId = setTimeout(revertToPrimary, SWAP_DURATION);
          return;
        }
        
        console.log('[SKU Image Swap] Swapping to secondary image');
        isCurrentlySwapped = true;
        
        // Clear any existing timeout
        if (timeoutId) {
          clearTimeout(timeoutId);
          timeoutId = null;
        }

        // Swap to alternate image using inline styles (override CSS)
        // Use setProperty with important flag to ensure it overrides CSS
        firstImage.style.setProperty('opacity', '0', 'important');
        altImage.style.setProperty('opacity', '1', 'important');

        // Set timeout to revert back after 3 seconds
        timeoutId = setTimeout(revertToPrimary, SWAP_DURATION);
        console.log('[SKU Image Swap] Timer set for', SWAP_DURATION, 'ms');
      }

      function revertToPrimary() {
        console.log('[SKU Image Swap] Reverting to primary image after', SWAP_DURATION, 'ms');
        isCurrentlySwapped = false;
        
        // Explicitly set opacity back with important flag
        firstImage.style.setProperty('opacity', '1', 'important');
        altImage.style.setProperty('opacity', '0', 'important');
        
        // After a brief moment, remove inline styles to let CSS take over
        setTimeout(() => {
          firstImage.style.removeProperty('opacity');
          altImage.style.removeProperty('opacity');
        }, 100);
        
        timeoutId = null;
      }

      // Step 5: Use click event only (works on both touch and mouse)
      // Click fires reliably on mobile after touch, and directly on mouse devices
      container.addEventListener('click', function(e) {
        console.log('[SKU Image Swap] Click event fired on container', index);
        e.preventDefault();
        e.stopPropagation();
        swapToSecondary();
      });
      
      console.log(`[SKU Image Swap] Container ${index}: Click handler attached`);
    });
  }

  // Initialize on DOM ready
  function init() {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => {
        initMobileImageSwap();
        initVariantButtons(document);
        initVariantButtonsDelegated();
      });
    } else {
      initMobileImageSwap();
      initVariantButtons(document);
      initVariantButtonsDelegated();
    }
  }

  init();

  // Re-initialize on Shopify section reload (theme editor)
  document.addEventListener('shopify:section:load', function(event) {
    console.log('[SKU Image Swap] Section reload detected');
    setTimeout(() => {
      initMobileImageSwap();
      initVariantButtons(document);
      initVariantButtonsDelegated();
    }, 100); // Small delay to ensure DOM is ready
  });
})();
